import { Text, ToggleDetails } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import DataGrid from "react-data-grid";
import { buildAssignmentTable } from "../utils";

const CanvasAssignmentSummary = ({ assignmentName, results }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const { outcomeColumns, studentRows } = buildAssignmentTable(results);
    setColumns(outcomeColumns);
    setRows(studentRows);
  }, [results]);

  return (
    <>
      <Text>
        <Text weight="bold">{t("finalizeCourse.selectedAssignment")}: </Text>
        {assignmentName}
      </Text>
      <ToggleDetails summary={t("finalizeCourse.toggleResults")}>
        <DataGrid
          className="rdg-light"
          rowHeight={60}
          headerRowHeight={40}
          columns={columns}
          rows={rows}
        />
      </ToggleDetails>
    </>
  );
};

export default CanvasAssignmentSummary;
